import { Badge } from '@/shared/ui/badge';
import { Lock } from 'lucide-react';

interface UserRolesCellProps {
  roles: { id: number; name: string; isSystem: boolean }[];
}

export function UserRolesCell({ roles }: UserRolesCellProps) {
  if (roles.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {roles.map((role) => (
        <Badge key={role.id} variant="secondary" className="gap-1">
          {role.isSystem && <Lock className="w-3 h-3" />}
          {role.name}
        </Badge>
      ))}
    </div>
  );
}
